function masking(str: string): string {
  if (!str) return '';
  if (str.length > 3) {
    return `${str.substring(0, 3)}***`;
  }
  return str;
}

export default masking;
